import { jsx, jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import { forwardRef } from "react";
import { MagnifyingGlass } from "../icons/MagnifyingGlass.js";
import classes from "./search-field.module.css";
const SearchField = forwardRef(function TextField(props, ref) {
  const {
    value,
    onFocus,
    onChange,
    autoFocus,
    className,
    collapseBorder,
    endAdornmentLabel,
    disableFocusVisual,
    slotProps: { input: inputProps, root: rootProps } = {}
  } = props;
  const rootClass = clsx(className, classes.root, rootProps?.className, {
    [classes.collapseBorder]: collapseBorder,
    [classes.disableFocusVisual]: disableFocusVisual
  });
  const inputClass = clsx(classes.input, inputProps?.className);
  return /* @__PURE__ */ jsxs("div", { ...rootProps, className: rootClass, ref, children: [
    /* @__PURE__ */ jsx(MagnifyingGlass, { className: classes.lens }),
    /* @__PURE__ */ jsx(
      "input",
      {
        autoComplete: "off",
        placeholder: "Search Stories",
        type: "text",
        ...inputProps,
        autoFocus,
        className: inputClass,
        onChange,
        onFocus,
        value
      }
    ),
    endAdornmentLabel ? /* @__PURE__ */ jsx("h6", { className: classes.adornment, children: endAdornmentLabel }) : null
  ] });
});
export {
  SearchField
};
//# sourceMappingURL=SearchField.js.map
